var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCookiesSocialMedia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)",
    fill: "#F4F4F4",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,2.60294867 L17.7543213,17.25 L2.24567871,17.25 L10,2.60294867 Z",
    stroke: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1C8.34314575 1 7 2.34314575 7 4 7 5.65685425 8.34314575 7 10 7 11.6568542 7 13 5.65685425 13 4 13 2.34314575 11.6568542 1 10 1ZM3 13C1.34314575 13 0 14.3431458 0 16 0 17.6568542 1.34314575 19 3 19 4.65685425 19 6 17.6568542 6 16 6 14.3431458 4.65685425 13 3 13ZM17 13C15.3431458 13 14 14.3431458 14 16 14 17.6568542 15.3431458 19 17 19 18.6568542 19 20 17.6568542 20 16 20 14.3431458 18.6568542 13 17 13Z",
    stroke: "#797979",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCookiesSocialMedia);
export default __webpack_public_path__ + "static/media/ic-cookies-social-media.b8077e6345c182232b44f3aaf661ec6d.svg";
export { ForwardRef as ReactComponent };